import React, { useEffect } from 'react';

import {
  Dropdown,
  DropdownChip,
  DropdownContent,
  DropdownRadioGroup,
  DropdownRadioItem,
  DropdownTrigger,
} from '@mesh.ai/rabbit';
import { useDispatch } from 'react-redux';
import { useReviewManageSidepanelData } from 'reducers/reviewManageSidepanelSlice';
import { checkEnableCompanySupport, checkReviewViewBasedFilterEnabled } from 'utils/helpers/featureFlags';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { useTimelineDataQuery } from '../hooks/useTimelineDataQuery';
import { setSelectedReviewsForm, useSelectReviewsSelectedForm } from '../slice/ReviewsIntentSlice';

export const ALL_VIEWS_TIMELINE = {
  name: 'All Views',
  feedbackFormId: 77777777,
  timelines: {},
  feedbackTimelines: [],
};

const ReviewManageTimelineFilter = () => {
  const dispatch = useDispatch();
  const { selectedReviewCycle } = useReviewManageSidepanelData();

  const { data: timelineData } = useTimelineDataQuery({
    selectedReviewCycle,
  });

  const selectedForm = useSelectReviewsSelectedForm();

  useEffect(() => {
    // we are clearing the selectedForm in ReviewManageReviewCycleDropdown
    if (timelineData?.length > 0 && !selectedForm) {
      const formToSelect =
        checkReviewViewBasedFilterEnabled() && timelineData.length > 1 ? ALL_VIEWS_TIMELINE : timelineData[0];
      dispatch(setSelectedReviewsForm(formToSelect));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, timelineData, ALL_VIEWS_TIMELINE]);

  const selectedFormId = String(selectedForm?.feedbackFormId);

  const handleSelect = (form) => {
    dispatch(setSelectedReviewsForm(form));
  };

  if (timelineData?.length === 0 || selectedReviewCycle?.reviewType === 'TRIGGERED') {
    return null;
  }

  let filteredTimelineData = timelineData;
  if (checkReviewViewBasedFilterEnabled() && timelineData && timelineData.length > 1) {
    filteredTimelineData = [ALL_VIEWS_TIMELINE, ...timelineData];
  }

  // This dropdown jsx is hidden when checkEnableCompanySupport flag is enabled to make enough space for the new filters to show demo to a new client. requested by - Sakshi.
  // keep this check here to make sure the component works as the useEffect in this is used to set the selected feedbackForm,
  // which is then used in the timeline component
  if (checkEnableCompanySupport()) {
    return null;
  }

  return (
    <Dropdown>
      <DropdownTrigger asChild>
        <DropdownChip>
          <TextBodyMedium bold color="text.g2" className="group-data[state=open]:text-[#004F67]">
            View Name:
          </TextBodyMedium>

          <TextBodyMedium bold color="text.g1">
            {selectedForm?.name}
          </TextBodyMedium>
        </DropdownChip>
      </DropdownTrigger>
      <DropdownContent
        align="start"
        style={{
          maxHeight: '250px',
          overflowY: 'auto',
          minWidth: '220px',
        }}
      >
        <DropdownRadioGroup value={selectedFormId}>
          {filteredTimelineData?.map((item) => (
            <DropdownRadioItem
              key={item.feedbackFormId}
              value={String(item.feedbackFormId)}
              onClick={() => handleSelect(item)}
            >
              {item.name}
            </DropdownRadioItem>
          ))}
        </DropdownRadioGroup>
      </DropdownContent>
    </Dropdown>
  );
};

export { ReviewManageTimelineFilter };
